module.exports = __webpack_public_path__ + "static/img/Ethan-Roberts.ab8b1d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ethan-Roberts.jpg
// module id = lqFz
// module chunks = 0